const API_BASE_URL = 'https://www.gianttrees.club/api';

export default {
  API_BASE_URL
};